import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-framer', 'BrandFramer', [["path",{"d":"M6 15h12l-12 -12h12v6h-12v6l6 6v-6"}]]);